import { Internationalisation } from "./internationalisation"
import { PricingSlider } from "./pricing_slider"
import { DesignController } from "./design_controller"
import { BetterFileInput } from "./better_file_input"
import { BlockInternetExplorer } from "./block_internet_explorer"
import { SvgAnimate } from "./svg_animate"
import { CopySignatureToClibpoard } from "./copy_signature_to_clibpoard"
import { Pagination } from "./pagination"
import { SignaturesController } from "./signatures_controller"
import { AnnouncementsController } from "./announcements_controller"
import { MacPCView } from "./mac_pc_view"
import { PaymentController } from "./payment_controller"
import { MetaSearchController } from "./meta_search_controller"
import { SidebarController } from "./sidebar_controller"
import { Tooltip, Popover, Modal, Collapse } from "bootstrap"
class MainController {
  constructor() {
    // readyFunction needs to be called (via turbo:load or jquery ready)
    // Internationalization is not jQuery dependant we can init it as soon as possible.
    new Internationalisation()
  }

  readyFunction = () => {
    console.log("ready function call")

    new BetterFileInput()
    new BlockInternetExplorer()
    new Pagination()
    new AnnouncementsController()
    new SignaturesController()
    new DesignController()
    new PaymentController()
    new MacPCView()
    new SidebarController()
    this.loadWebsiteWideElements()
    this.animateSubscribe()
    this.injectBootstrapSpins()
    this.closeFlashDivButton()
    this.closeSmartScreenModal()
    this.userOrganizationsEditForm()
    this.userPromtionAlertOption()
    this.changeOnSelectFilter()
    this.collapseAnchors()

    this.verifyGoogleServiceAccount()

    this.spinWhileSignatureImgGenerates()

    new SvgAnimate()
    new PricingSlider()
    new CopySignatureToClibpoard()
    new MetaSearchController()
  }

  closeModal(modalId) {
    let myModal = Modal.getInstance(document.getElementById(modalId))
    myModal.hide()
  }

  loadWebsiteWideElements = () => {
    // This elements can be present almost anywhere in the website
    console.log("Loading WebsiteWideElements")
    this.betterSelects()
    this.loadBootstrapPopovers()
    this.loadBootstrapTooltips()
  }

  copyLinkNoPassword = () => {
    new CopySignatureToClibpoard().textWithButtonForClipboardCopy()
  }

  closeSmartScreenModal = () => {
    $(".js-closeModalOnClick").on("click", (e) => {
      this.closeModal("myModalSmartScreen")
    })
  }

  spinWhileSignatureImgGenerates = () => {
    const jsImgRefresh = document.getElementsByClassName("js-img-refresh")
    if (jsImgRefresh.length == 0) {
      return
    }
    const imgs = jsImgRefresh[0].getElementsByTagName("img")
    // Make an array of the social media icons source
    const srcArray = []

    Array.from(imgs).forEach((img) => {
      srcArray.push(img.src)
    })

    const spin = document.getElementById("js-spin")

    let randomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    let imgRefreshTimeOut = setTimeout(imgSrcReload, 1000)

    function imgSrcReload() {
      // replace the icons source with itself followed by a rand number
      let allImageClean = true
      Array.from(imgs).forEach(function (img, index) {
        if (img.naturalWidth == 1) {
          allImageClean = false
          img.src = srcArray[index] + "?" + randomInt(10, 1000)
        }
      })

      if (allImageClean) {
        // If all icons are loaded clear timeout
        clearTimeout(imgRefreshTimeOut)
        spin.style.display = "none"
      } else {
        // If at least one icon size is of 1 px (means its blank) run the function again
        imgRefreshTimeOut = setTimeout(imgSrcReload, 1000)
      }
    }
  }

  loadBootstrapPopovers = () => {
    $(() => {
      var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
      )
      var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl, {
          container: "body",
        })
      })
    })
  }

  loadBootstrapTooltips = () => {
    $(() => {
      var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      )
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl, {
          boundary: "window",
        })
      })
    })
  }

  changeOnSelectFilter = () => {
    $("select.js-FilterSelect").on("change", (e) => {
      const filterField = e.target.dataset.filterField
      const filterValue = e.target.value
      const search = new URLSearchParams(window.location.search)
      search.set(filterField, filterValue)
      window.location.search = search
    })

    $("a.js-FilterClear").on("click", (e) => {
      e.preventDefault()

      const filterField = $(e.target).closest("a").data("filterField")
      const search = new URLSearchParams(window.location.search)
      search.delete(filterField)
      //console.log("search: ", search, filterField)
      window.location.search = search
    })
  }

  collapseAnchors = () => {
    $(".js-CollapseAnchor").on("click", (e) => {
      const collapseToOpen = $(e.target)
        .attr("href")
        .replace("#", "")
        .replace("Title", "")

      document
        .querySelectorAll(`.collapse:not(#${collapseToOpen})`)
        .forEach((e) => {
          Collapse.getOrCreateInstance(e).hide()
        })
      Collapse.getOrCreateInstance(
        document.getElementById(collapseToOpen)
      ).show()
    })
  }

  userOrganizationsEditForm = () => {
    if ($(".js-organization_admin_organizations").length > 0) {
      const selectSelector = "select.js-type-for-user"
      $(selectSelector).on("change", (e) => {
        if ($(selectSelector).val() == "OrganizationAdmin") {
          $(".js-organization_admin_organizations")
            .removeClass("d-none")
            .addClass("show")
        } else {
          $(".js-organization_admin_organizations")
            .removeClass("show")
            .addClass("d-none")
        }
      })

      $(selectSelector).trigger("change") // Take care of the initial state.
    }
  }

  userPromtionAlertOption = () => {
    var promotionAlertOption = $(".js-send_promotion_email")
    if (promotionAlertOption.length > 0) {
      const userTypeSelector = "select.js-type-for-user"
      $(userTypeSelector).on("change", (e) => {
        if ($(userTypeSelector).val() == "CompanyAdmin") {
          promotionAlertOption.removeClass("d-none")
        } else {
          promotionAlertOption.addClass("d-none")
        }
      })
    }
  }

  closeFlashDivButton = () => {
    $(".js-close-flash").on("click", (e) => {
      $(e.target).parents(".js-flash-div").remove()
    })
  }

  injectBootstrapSpins = () => {
    var target = document.getElementById("js-spin")
    if (target != null) {
      target.innerHTML = main.bootstrapSpinner()
    }
  }

  animateSubscribe = () => {
    $(".button-action a").on("click", (e) => {
      var subscribeForm = $($(e.target).data("targetform"))

      if (subscribeForm.hasClass("d-none")) {
        subscribeForm.fadeIn()
        setTimeout(function () {
          $("#signature_email").trigger("focus")
        }, 2)

        subscribeForm.removeClass("d-none")
      } else {
        subscribeForm.addClass("d-none")
      }
    })
  }

  bootstrapSpinner = (additionStyle) => {
    const spinner = `<div class="position-absolute" style="${additionStyle}"><div class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Loading...</span></div></div>`
    return spinner
  }

  verifyGoogleServiceAccount = () => {
    $(".js-verification_google_service_account").on("click", function () {
      $("#js-spin-target").html(main.bootstrapSpinner())
      const emailExReg =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
      const emailAccount = $("#company_google_service_account_email")
        .val()
        .trim()
      const companyId = $("#company_id").val().trim()
      if (emailExReg.test(emailAccount)) {
        const fullUrl =
          $("#js-address_for_rights_verification").text().trim() +
          "&email_account=" +
          emailAccount +
          "&company_id=" +
          companyId
        console.log("full url :", fullUrl)
        $.ajax(fullUrl)
      } else {
        const message = "Please provide a valid email"
        $(".js-verification_google_service_account").text(message)
        $("#js-spin-target").html("")
      }
    })
  }

  betterSelects = () => {
    // http://silviomoreto.github.io/bootstrap-select/examples/
    $("select.js-smarter-select").selectpicker({
      size: 8,
      iconBase: "fa",
    })
  }
}

const main = new MainController()

// Make main useable from other parts of the code
// Ex pagination

export { main }
